import styled from "styled-components"
import { IoMenu } from "react-icons/io5";

import { Link, NavLink, useLocation } from "react-router-dom";
import { handleIsSmSidebarHovered, handleSidebar } from "../../../features/layout/layoutSlice";
import { useDispatch, useSelector} from "react-redux";
import { useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { showedMenusIcons } from "../../../utils/navItems/showedMenus";

import aiAvatarLight from "../../../images/svg/ai/aiAvatarLight.svg"
import aiAvatarDark from "../../../images/svg/ai/aiAvatarDark.svg"

const Container = styled.div`
    width: 85px;
    min-height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: ${({theme}) => theme.mainBgColor};
    border-right: 1px solid ${({theme}) =>  theme.mainBorderColor};
    z-index: 25;

    .top-side{
        width: 100%;
        height: 80px;
        border-bottom: 1px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;

        .menu-icon{
            font-size: 1.6rem;
            color: ${({theme}) => theme.mainTextColor};
            cursor: pointer;
        }
    }

    .nav{
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-right: 0;
        position: relative;
        height: calc(100vh - 80px);

        .navlink-icon{
            height: 42px;
            width: 100%;
            display: flex;
            align-items: center;
            border-radius: 20px 0 0 20px;
            padding-left: 10px;
            cursor: pointer;
            position: relative;

            &:hover{

                .navlink-text-wrapper{
                    border-radius: 0 !important;
                }
            }

            .navlink-text-wrapper{
                height: 42px;
                width: 260px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 10px;
                cursor: pointer;
                position: absolute;
                top: 0;
                right: -260px;
                background-color: ${({theme}) => theme.mainBgColor};
                border-right: 1px solid ${({theme}) => theme.mainTextColor};
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                color: ${({theme}) => theme.mainTextColor};
                &:hover{
                    border-radius: 0 !important;
                }

                .navlink-text{
                    position: relative;
                    top: -30px;
                }
            }

            .active-navlink-text-wrapper{
                background-color: ${({theme}) => theme.secondaryBgColor};
                color: var(--color-main);
            }

            .hover-navlink-text-wrapper{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }

        .ai-link{
            height: 38px;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-radius: 20px 0 0 20px;
            cursor: pointer;
            margin-right: 18px;
            margin-top: auto;

            .ai-icon{
                width: 100%;
                height: 100%;
            }

        }

        .hover-navlink-icon{
            background-color: ${({theme}) => theme.secondaryBgColor};

        }

        .active-navlink-icon{
            background-color: ${({theme}) => theme.secondaryBgColor};
            color: var(--color-main);
        }
    }
`

const SidebarSm = ({navItems}) => {
    
    const dispatch = useDispatch()

    const {diffPageList, theme, isSmSidebarHovered, mustSmSidebarPageList} = useSelector(state => state.layout)

    const [hoveredItemId, setHoveredItemId] = useState(null)

    const path = useLocation().pathname
    
  return (
    <Container isHovered={isSmSidebarHovered} onMouseEnter={() => dispatch(handleIsSmSidebarHovered(true))} onMouseLeave={() => dispatch(handleIsSmSidebarHovered(false))}>
    <div className="top-side">
        <IoMenu className="menu-icon" onClick={() => {dispatch(handleSidebar((diffPageList.includes(path) || mustSmSidebarPageList.includes(path)) ? "hidden" : "wide")); dispatch(handleIsSmSidebarHovered(false))}} />
    </div>
    <nav className="nav">
        {
            navItems?.filter(item =>item?.id !== 20)?.map((item, i) => {
                
                return (
                <NavLink key={item.id} to={item.permission?.[0].slug} onClick={() => dispatch(handleIsSmSidebarHovered(false))} onMouseEnter={() => setHoveredItemId(item.id)} onMouseLeave={() => setHoveredItemId(null)}  className={item.permission?.[0].slug?.split("/")[1] === path?.split("/")[1] ? "active-navlink-icon navlink-icon" : item.id === hoveredItemId ? "navlink-icon hover-navlink-icon" : "navlink-icon"}>{showedMenusIcons?.find(it => it.text === item.permission?.[0].slug?.split("/")[1])?.icon}
                    {
                        isSmSidebarHovered &&
                        <div onClick={() => dispatch(handleIsSmSidebarHovered(false))} className={item.permission?.[0].slug.split("/")[1] === path?.split("/")[1] ? "active-navlink-text-wrapper navlink-text-wrapper" : item.id === hoveredItemId ? "hover-navlink-text-wrapper navlink-text-wrapper" : "navlink-text-wrapper"} style={{borderTopRightRadius: i === 0 && "10px", borderBottomRightRadius: i === navItems.length-1 && "10px", borderRight: (hoveredItemId === item.id && item.permission.length > 0) && (theme === "dark" ? "#333434" : "#fff")}}><span>{item.name}</span> 
                        <div>
                            {
                                item.permission.length > 1 &&
                                <IoIosArrowForward />
                            }
                            {
                                (hoveredItemId === item.id && item.permission.length > 1) &&
                                <div className="navlink-text">
                                    <SubItemsContainer item={item}/>
                                </div>
                            }
                            </div>
                        </div>
                    }
                </NavLink>
            )})
        }
        {
            navItems?.find(item => item.id === 20) &&
            <Link to={navItems?.find(item => item?.id === 20)?.permission[0]?.slug} className="ai-link">
                <img src={theme === "dark" ?  aiAvatarDark : aiAvatarLight} className="ai-icon" alt="" />
            </Link>
        }
    </nav>
    </Container>
  )
}


const SubItemsCont = styled.div`
    position: absolute;
    top: ${({isEnd})=> !isEnd ? 0 : "100px"};
    bottom: ${({isEnd})=> isEnd && "-12px"};
    right: -310px;
    width: 300px;
    height: auto;
    max-height: 377px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    background-color: ${({theme}) => theme.mainBgColor};
    border-radius: 0 10px 10px 0;

    .subItem{
        padding: 13px 10px;
        display: flex;
        align-items: center;
        color: ${({theme}) => theme.mainTextColor};

        &:hover{
            background-color: ${({theme}) => theme.secondaryBgColor};
        }
    }

    .active-subItem{
        color: var(--color-main);
    }


    @media (max-height: 900px) {
        max-height: 200px !important;
    }
`

const SubItemsContainer = ({item}) => {

    const dispatch = useDispatch()

    return (
        <SubItemsCont isEnd={item.id === 18}>
        {
            item.permission.map((subItem,i) => (
                <NavLink to={subItem.slug} key={i} onClick={() => dispatch(handleIsSmSidebarHovered(false))} className={({isActive})=> isActive ? "active-subItem subItem" : "subItem"}>{subItem.description}</NavLink>
            ))
        }
    </SubItemsCont>
    )
}

export default SidebarSm